import React from "react";
import { styled, Box } from "@mui/material";

const Wrapper = styled(Box)(({ theme }) => ({
  "&": {
    p: { ...theme.typography.body2 },
    select: {
      boxShadow: "none",
    },
    textarea: {
      border: `2px solid ${theme.palette.divider}`,
    },
    " table tbody tr td:first-of-type": {
      paddingRight: 10,
    },
    ".wrapper": {
      padding: 0,
    },
    ".parameter__in": theme.typography.caption,
    ".btn": {
      boxShadow: "none",
      "&.authorize": {
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        svg: {
          fill: theme.palette.primary.main,
        },
      },
      "&.execute": {
        background: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
    ".scheme-container": {
      background: "unset",
      boxShadow: "unset",
    },
    ".auth-wrapper .authorize": {
      margin: 0,
    },
    ".opblock": {
      boxShadow: "none",
      "&.opblock-get": {
        background: "#fafafa",
        borderColor: theme.palette.divider,
        ".opblock-summary": {
          border: "none",
        },
        ".opblock-summary-method": {
          background: theme.palette.primary.main,
        },
      },
      "&.opblock-post": {
        background: " #fefefe",
        borderColor: theme.palette.divider,
        ".opblock-summary": {
          border: "none",
        },
      },
      ".opblock-section-header": {
        background: "transparent",
        boxShadow: "none",
        borderBottom: `1px solid ${theme.palette.divider}`,
        borderTop: `1px solid ${theme.palette.divider}`,
      },
      ".opblock-summary-path": theme.typography.subtitle2,
      ".opblock-summary-description": theme.typography.body2,
      ".opblock-summary-method": theme.typography.button,
    },
    ".opblock-tag": {
      borderBottom: "none",
    },
    ".response-col_links": {
      display: "none",
    },
    "section.models": {
      "&.models": {
        borderColor: theme.palette.divider,
        background: theme.palette.background.paper,
        "&.is-open": {
          "& h4": {
            borderColor: theme.palette.divider,
          },
        },
      },
    },
  },
}));

interface SwaggerWrapperProps {
  children: React.ReactNode;
}
const SwaggerWrapper = ({ children }: SwaggerWrapperProps) => {
  return <Wrapper>{children}</Wrapper>;
};

export default SwaggerWrapper;
